import Languages from '@cospired/i18n-iso-languages'
import FR from '@cospired/i18n-iso-languages/langs/fr.json'
import EN from '@cospired/i18n-iso-languages/langs/en.json'

Languages.registerLocale(FR)
Languages.registerLocale(EN)

export const languageGetName = (
  code: string,
  lang: string
) => {
  
  return Languages.getName(code, lang) ?? code
}

export const languageGetList = (
  lang: string
) => {
  if (!lang) return { main: [], all: [] }
  
  const all = Object.entries(Languages.getNames(lang))
  const main = all.filter(n => ['fr', 'en', 'es', 'de'].includes(n[0]))

  return {
    main: main.map(([ code, name ]) => ({ label: name, value: code })),
    all: all.map(([ code, name ]) => ({ label: name, value: code }))
  }
}
